import { VIEW_ONLY_DISABLED_MESSAGE } from '@mentimeter/editor-essentials/constants';
import {
  EditorOverviewDataHandler,
  OverviewListViewOnly,
} from '@mentimeter/editor-overview-data-handlers';
import type { OverviewListItemType } from '@mentimeter/editor-overview-ui';
import type { Theme } from '@mentimeter/http-clients';
import { SlidesOverviewLayout } from 'app/(tracked)/[seriesId]/(collaborator)/(editor)/editor-layout-components/SlidesOverviewLayout';
import { AddSlideButtonWithTooltip } from 'features/core/editor/Header/components/AddSlideButtonWithTooltip';

export const ViewOnlySlidesOverview = ({
  amountOfSlides,
  activeSlideIndex,
  seriesTheme,
  activeQuestionId,
  overviewListItems,
  userIsViewOrCommentCollaborator,
  showHorizontalOverviewList,
  onClickSlideThumbnail,
  onClickCommentIcon,
}: {
  amountOfSlides: number;
  activeSlideIndex: number;
  seriesTheme: Theme;
  activeQuestionId: string;
  overviewListItems: OverviewListItemType[];
  userIsViewOrCommentCollaborator: boolean;
  showHorizontalOverviewList: boolean;
  onClickSlideThumbnail: (slideId: string) => void;
  onClickCommentIcon: () => void;
}) => {
  const content = (
    <>
      <AddSlideButtonWithTooltip
        disabled={true}
        showAddSlidePopover={false}
        description={VIEW_ONLY_DISABLED_MESSAGE}
        showIconButton={showHorizontalOverviewList}
      />
      <OverviewListViewOnly
        seriesTheme={seriesTheme}
        activeQuestionId={activeQuestionId}
        overviewListItems={overviewListItems}
        userIsViewOrCommentCollaborator={userIsViewOrCommentCollaborator}
        onClickSlideThumbnail={onClickSlideThumbnail}
        onClickCommentIcon={onClickCommentIcon}
        showHorizontalOverviewList={showHorizontalOverviewList}
      />
    </>
  );

  return (
    <SlidesOverviewLayout
      showHorizontalOverviewList={showHorizontalOverviewList}
    >
      {showHorizontalOverviewList ? (
        content
      ) : (
        <EditorOverviewDataHandler
          amountOfSlides={amountOfSlides}
          activeSlideIndex={activeSlideIndex}
        >
          {content}
        </EditorOverviewDataHandler>
      )}
    </SlidesOverviewLayout>
  );
};
